import { environment } from "./environment";

export class Constants
{
  static authenticationUrl = `${ environment.api }/authenticate`;
  // static initialCredentials  = `client_id=${ environment.clientId }&client_secret=${ environment.clientSecret }&grant_type=integrated&scope=offline_access%20roles%20profile`;
  // refreshCredentials  = ( clientId: string, clientSecret: string ) => `client_id='${ clientId }'&client_secret='${ clientSecret }'&grant_type=refresh_token&refresh_token=`;

  static usersUrl = `${ environment.api }/users`;
  static usersResetPasswordUrl = `${ environment.api }/users/resetpassword`;
  static coursesUrl = `${ environment.api }/courses?$expand=sections($expand=units($expand=exercises))`;
  static progressesUrl = `${ environment.api }/progresses`;
  static statisticsUrl = `${ environment.api }/statistics`;
  static exerciseAnswersUrl = `${ environment.api }/exerciseanswers`;
  static diagramContainersUrl = `${ environment.api }/diagramcontainers`;
  static progressUrl = ( id ) => `${ Constants.progressesUrl }/${ id }`;
  static exercisesUrl = `${ environment.api }/exercises`;
  static registrationsUrl = `${ environment.api }/registrations`;

  static videos = {
    testDriveUrl: `${ environment.videosUrl }/TestDrive.mp4`,
    course:
    {
      // 1
      imposingTheStructure: 'Lecture 1A_Imposing the Structure_11.08.20.mp4',
      pickingOutThePoints: 'Lecture 1B_Cementing the Rules_11.08.20.mp4',
      cementingTheRules: 'Lecture 1C_Picking Out the Points_12.08.20.mp4',
      graspingTheMessage_1: 'Lecture 1D - Grasping the Message_13.08.20.mp4',
      graspingTheMessage_2: 'Lecture 1D-2_Finding the Summary Point_27.08.20.mp4',
      // 2
      ideasFitTogether_1: 'Lecture 2A_How the Ideas Fit Together_31.08.20.mp4',
      ideasFitTogether_2: 'Lecture 2A - 2_Identify First Idea_07.09.20.mp4',
      creatingQuestion: 'Lecture 2B_Creating a Question Answer Dialogue_12.09.20.mp4',
      // 3
      deductiveReasoning: 'Lecture 3A - 1_ Deductive Arguments_12.09.20.mp4',
      inductiveReasoning: 'Lecture 3B - 1_ Inductive Reasoning_13.09.20.mp4',
      deductionToInduction: 'Lecture 3B - 4_Transforming Deduction to Induction_14.09.20.mp4',
      avoidingDeductiveArguments: 'Lecture 3C_Avoiding Deductive Arguments_14.09.20.mp4',
      // 4
      practiceInSeeing: 'Lecture 4A_Introductions - Reading to Get the Rhythm_16.09.20.mp4',
      findingReadersQuestion: 'Lecture 4B - 1_Seeing the SCQ Structure_22.09.20.mp4',
      spottingSCQ: 'Lecture 4B-2_Finding the Reader_s Question_22.09.20.mp4',
      applyingSCQProcess: 'Lecture 4C-1_Applying the SCQ Process_23.09.20.mp4',
      practiceInSeeing3: 'Lecture 4C-2_Field_Sales_Meeting_22.11.20.mp4',
      // 5
      defineProblem: 'Lecture 5A_How to Define a Problem_27.09.20.mp4',
      practiceDefiningProblem: 'Lecture 5B_Defining the Problem_27.09.20.mp4',
      definingMoreComplexProblems: 'Lecture 5C_Converting an Introduction_27.09.20.mp4',
      writingAGoodProposal: 'Lecture 5D_Writing Proposals and Project Plans_29.09.20.mp4'
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/services/constants.js